export default __webpack_public_path__ + "static/media/hello-dark.09d96f0e.webp";